
import {
    defineComponent,
    computed,
    toRefs,
    ref,
    PropType,
    reactive
} from 'vue';

import {
    ElDialog,
    ElForm,
    ElSelect,
    ElOption,
    ElSwitch,
    ElButton,
    ElMessage
} from 'element-plus';
import { AlbumId, AlbumModel, ArtistModel, RankVersion } from '@/typings';

import { formatTS } from '@/utility';
import { articleWriteSubVersionItemAlbum, myRankVerions, uploadArticle } from '@/services';

import AlbumItem from '@/components/EntityListItem/AlbumItem.vue';
import ArtistItem from '@/components/EntityListItem/ArtistItem.vue';

export default defineComponent({
    components: {
        ElDialog,
        ElForm,
        ElSelect,
        ElOption,
        ElSwitch,
        ElButton,
        AlbumItem,
        ArtistItem
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        id: {
            type: String as unknown as PropType<AlbumId>,
            required: true
        },
        type: {
            type: String as PropType<'album' | 'artist'>,
            default: 'album'
        },
        album: {
            type: Object as PropType<AlbumModel>,
            default () {
                return {};
            }
        },
        artist: {
            type: Object as PropType<ArtistModel>,
            default () {
                return {};
            }
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        'update:visible' (val:boolean) {
            return true;
        },
        change () {
            return true;
        }
    },
    setup (props, { emit }) {
        const {
            visible,
            id
        } = toRefs(props);

        const dialogFormVisible = computed({
            get: () => visible.value,
            set: (val) => emit('update:visible', val)
        });

        const dialogTitle = ref('');

        const loadings = reactive({
            formLoading: false,
            writer: false
        });

        const formEditRank = reactive({
            rank_in_head: false,
            content: '',
            rank_version_index: 0
        });

        const rank_versions = ref<RankVersion[]>([]);
        myRankVerions().then((json) => {
            rank_versions.value = json.data.articles;
        });

        const md = ref<any>(null);
        const doImgAdd = (pos:any, $file:any) => {
            loadings.writer = true;

            const formdata = new FormData();
            formdata.append('image', $file);
            formdata.append('article_id', id.value);

            uploadArticle(formdata).then((json) => {
                md.value.$img2Url(pos, json.data.url);
                ElMessage.success('上传成功');
            }).finally(() => {
                loadings.writer = false;
            });
        };

        const imgDel = () => {
        // TODO 原始代码就是空
        };

        const doConfirmEdit = () => {
            const article_list = rank_versions.value[formEditRank.rank_version_index];
            articleWriteSubVersionItemAlbum({
                reference_id: id.value,
                main_article_id: article_list._id,
                main_rank_id: {
                    _id: article_list.main_rank_id._id
                },
                content: formEditRank.content
            }).then(() => {
                ElMessage.success('添加成功');
                emit('change');
                dialogFormVisible.value = false;
            }).catch((json) => {
                ElMessage.error(json.data.msg);
            });
        };
        return {
            dialogFormVisible,
            dialogTitle,
            loadings,
            formEditRank,
            formatTS,
            rank_versions,
            doImgAdd,
            imgDel,
            doConfirmEdit
        };
    }

});
